const module = angular.module('webremote.directive.objectmanager.wizard', [])

require('./navigation/controller')
require('./content/controller')
require('./pagination/controller')
require('./container/controller')
